<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
                <el-breadcrumb-item>单位信息</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id' highlight-current default-expand-all></el-tree>
                <!-- <p class="main-left-p">
                    <span>共{{entList.length}}个参建单位</span>
                    <el-button size="mini" type="primary" icon="el-icon-plus" @click="addEntFun">添加</el-button>
                </p>
                <div class="main-left-list">
                    <ul>
                        <li v-for="item in entList" :key="item.projectEntId" :class="{'curEnt':joinEntId==item.projectEntId}" @click="getEntId(item)">
                            <div class="unit-type">
                                {{item.label}}
                            </div>
                            <div class="unit-name color4">
                                <p :title="item.entName" class="nowrap">{{item.entName}}</p>
                                <p><i class="el-icon-s-custom"></i> {{item.personCount}}人</p>
                            </div>
                        </li>
                    </ul>
                </div> -->
            </div>
            <div class="main-table">
                <div class="table-box">
                    <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                        <template slot="empty">
                            <p>{{dataText}}</p>
                        </template>
                        <el-table-column label="序号" type="index" width="80"></el-table-column>
                        <el-table-column label="班组名称" width="100">
                            <template slot-scope="scope">
                                <!-- <router-link :to="'/teamWorker/'+scope.row.id" class="color5" :title="scope.row.name">{{scope.row.name}}</router-link> -->
                                <span class="color5" style="cursor: pointer;" @click="toTema(scope.row)">{{scope.row.name}}</span>
                                <!-- <span >{{scope.row.name}}</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="班组类型">
                            <template slot-scope="scope">
                            <span v-if="scope.row.teamsType=='1'">工人</span>
                            <span v-else-if="scope.row.teamsType=='3'">特种</span>
                            <span v-else-if="scope.row.teamsType==''"></span>
                            <span v-else>管理人员</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="班组人数">
                            <template slot-scope="scope">
                            <span>{{ scope.row.num }}人</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="班组长">
                            <template slot-scope="scope">
                            <span>{{scope.row.managerName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="电话号码">
                            <template slot-scope="scope">
                            <span>{{scope.row.managerTel}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" width="200">
                            <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button size="mini" v-if="isMenuExit('pro:team:edit')" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                                <el-button size="mini" v-if="isMenuExit('pro:team:del')" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column> -->

                        <!-- 新增窗口 -->
                        <el-dialog
                            :title="diaTitle"
                            :visible.sync="addFormVisible"
                            center
                            :append-to-body="true"
                            :lock-scroll="false"
                            width="30%"
                        >
                            <el-form
                            :model="addForm"
                            ref="addForm"
                            label-width="150px"
                            label-position="right"
                            class="teamPage"
                            :rules="teamRules"
                            >
                                <el-form-item label="班组名称" prop="name">
                                    <el-input v-if="addForm.jgStatus!='2'" v-model="addForm.name" autocomplete="off"></el-input>
                                    <p v-else >{{addForm.name}}<span style="color:#F56C6C;">(上传监管平台，无法修改)</span></p>
                                    <!-- <el-input v-else v-model="addForm.name" autocomplete="off" style="width:220px"></el-input> -->
                                </el-form-item>
                                <el-form-item label="班组类型：" prop="teamsType">
                                    <el-select v-if="addForm.jgStatus!='2'" v-model="addForm.teamsType" placeholder="请选择">
                                        <el-option
                                            v-for="item in teamTypes"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                    <p v-else >{{addForm.teamsTypeName}}<span style="color:#F56C6C;">(上传监管平台，无法修改)</span></p>
                                </el-form-item>
                                <!-- <el-form-item label="参建单位：" prop="projectEntId">
                                    <el-select
                                    v-if="addForm.id==''"
                                    v-model="addForm.projectEntId"
                                    clearable
                                    filterable
                                    placeholder="请选择"
                                    >
                                    <el-option
                                        v-for="item in ents"
                                        :key="item.id"
                                        :label="'('+item.typeName+')'+item.entName"
                                        :value="item.id"
                                    ></el-option>
                                    </el-select>
                                    <p v-else>{{'('+addForm.joinTypeName+')'+addForm.entName}}</p>
                                </el-form-item> -->
                                <el-form-item label="班组长：" prop="teamManager">
                                    <el-select
                                    v-model="addForm.teamManager"
                                    clearable
                                    filterable
                                    @change="changeManagerFun"
                                    placeholder="请选择"
                                    >
                                    <el-option
                                        v-for="item in teamPersons"
                                        :key="item.personId"
                                        :label="item.name+'('+item.idcard+')'"
                                        :value="item.personId"
                                    ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="联系电话：" prop="managerTel">
                                    <el-input v-model="addForm.managerTel" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="备注：">
                                    <el-input
                                    v-model="addForm.remarks"
                                    type="textarea"
                                    placeholder="请输入内容"
                                    autocomplete="off"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="addFormVisible = false">取 消</el-button>
                                <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                            </div>
                        </el-dialog>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
        :title="entTitle"
        :visible.sync="entVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="28%"
        >
        <el-form
            :model="addEnt"
            ref="addEnt"
            :rules="rules"
            label-width="150px"
            label-position="right"
            class="joinEnt"
        >
            <el-form-item label="统一信用社代码：" prop="creditCode">
                <el-input
                    v-if="addEnt.id==''"
                    v-model="addEnt.creditCode"
                    autocomplete="off"
                    @change="getEnvFun"
                ></el-input>
                <p v-else>{{addEnt.creditCode}}</p>
            </el-form-item>
            <el-form-item label="单位名称：" prop="entName">
                <el-input
                    v-if="addEnt.id==''"
                    v-model="addEnt.entName"
                    autocomplete="off"
                ></el-input>
                <p v-else>{{addEnt.entName}}</p>
            </el-form-item>
            <el-form-item label="单位类型：" prop="joinType">
                <el-select v-if="addEnt.id==''" v-model="addEnt.joinType" placeholder="请选择">
                    <el-option
                    v-for="item in entsTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    ></el-option>
                </el-select>
                <p v-else>{{addEnt.label}}</p>
            </el-form-item>
            <el-form-item label="单位联系人：" prop="name">
                <el-input v-model="addEnt.name" autocomplete="off"></el-input>
                <!-- <el-select
                    v-model="addEnt.personId"
                    clearable
                    filterable
                    @change="changePerson"
                    placeholder="请选择"
                >
                    <el-option
                    v-for="item in persons"
                    :key="item.personId"
                    :label="item.name+'('+item.idcard+')'"
                    :value="item.personId"
                    ></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
                <el-input v-model="addEnt.phone" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="entVisible = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddEnt('addEnt')">确 定</el-button>
        </div>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
    data(){
        var checkphone = (rule, value, callback) => {
        // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
            if (value == '') {
                callback(new Error('请输入手机号'))
            } else if (!this.isCellPhone(value)) {
                //引入methods中封装的检查手机格式的方法
                callback(new Error('请输入正确的手机号!'))
            } else {
                callback()
            }
        }
        return{
            entName:'',//参建单位查询
            groupId:'',
            entList:[],//参建单位list
            entsTypes:[],//参建单位类型list
            entTitle:'',//参建单位弹出框名称
            entVisible:false,
            persons:[],//参建单位的管理人员
            addEnt:{
                id: '',
                joinType: '1',
                creditCode: '',
                entName: '',
                entId: '',
                name:'',
                phone: '',
            },
            rules: {
                creditCode: [
                { required: true, message: '请输入统一信用社代码', trigger: 'blur' }
                ],
                entName: [
                { required: true, message: '请输入单位名称', trigger: 'blur' }
                ],
                name: [
                { required: true, message: '请选择单位联系人', trigger: 'blur' }
                ],
                phone: [{ required: true, validator: checkphone, trigger: 'blur' }] //validator: checkphone是验证手机的引入checkphone函数
            },
            joinEntId:'',//当前展示参建企业
            curProjectId:'',//当前展示项目
            //////////////////////////////////////////////////
            tableDataEnd:[],//班组列表
            diaTitle:'添加班组',//班组添加名称
            teamTypes: [
                { label: '工人', value: '1' },
                { label: '管理人员', value: '2' },
                { label: '特种', value: '3' }
            ],
            addFormVisible:false,//班组添加弹出框
            teamRules: {
                name: [{ required: true, message: '请输入班组名称', trigger: 'blur' }],
                teamsType: [
                { required: true, message: '请选择班组类型', trigger: 'blur' }
                ],
                projectEntId: [
                { required: true, message: '请选择参建单位', trigger: 'blur' }
                ],
                teamManager: [
                { required: true, message: '请选择班组长', trigger: 'blur' }
                ],
                managerTel: [{ required: true, validator: checkphone, trigger: 'blur' }] //validator: checkphone是验证手机的引入checkphone函数
            },
            dataText: '数据加载中...',
            addForm: {
                id: '',
                name: '',
                teamsType: '1',
                creditCode: '',
                remarks: '',
                projectEntId: '',
                teamManager: '',
                managerTel: ''
            },
            teamName:'',//班组名称
            teamPersons:[],//班组人员
            entInfo:{
                entName:'',
                joinType:'',
                creditCode:'',
                personName:'',
                personPhone:'',
                id:''
            },
            dataTree:[],
            defaultProps:{
                children: 'children',
                 label: 'name'
            },
        }
    },
    mounted(){
        util.common.filterBtnMenu('')
        var port = util.session.get('roleId')
        this.groupId = util.session.get('groupId')
        this.getTreeData()
        // this.getPerson()
    },
    methods:{
        //获取参建单位
        // getJoinEnt(){
        //     var that = this
        //     myHttp.getProjectEntByProjectId({
        //         projectId:this.groupId
        //     }).then(function(resp){
        //         if (resp.data.code == '200'){
        //             var list = resp.data.data.projectEnt || []
        //             if(list.length>0){
        //                 if(that.joinEntId==''){
        //                     that.joinEntId = list.length>0?list[0].projectEntId:''
        //                     that.entInfo = list[0]
        //                 }else{
        //                     for(var i=0;i<list.length;i++){
        //                         if(that.joinEntId == list[i].projectEntId){
        //                             that.entInfo = list[i]
        //                         }
        //                     }
        //                 }
        //                 that.getData()
        //             }else{
        //                 that.dataText = '暂无数据'
        //             }
        //             that.entList = list
        //         }else{

        //         }
        //     })
        // },

        //获取参建单位类型
        // getJoinType() {
        //     var that = this
        //     myHttp.getDictByType({
        //         type: 'join_type'
        //     }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //             var list = resp.data.data.dictList || []
        //             that.entsTypes = list
        //         }
        //         that.getJoinEnt()
        //     })
        // },
        //获取左边树形
        getTreeData(){
            var that = this
            myHttp.selectEntIdAndNameByEntIdAndJoinType({
                entId:this.groupId,
                joinType:'2',
                flag:'1'
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    var curKey = ''
                    var projectEntId = ''
                    if(list.length>0){
                        for(var i=0;i<list.length;i++){
                            if(list[i].children.length>0){
                                if(curKey==''){
                                    curKey = list[i].children[0].id
                                    that.curProjectId = list[i].id
                                    projectEntId = list[i].children[0].projectEntId
                                }
                                for(var j=0;j<list[i].children.length;j++){
                                    list[i].children[j].parentId = list[i].id
                                }
                            }
                        }
                    }
                    that.dataTree = list
                    that.joinEntId = projectEntId
                    that.getData()
                    setTimeout(function(){
                      that.$refs.tree.setCurrentKey(curKey)
                    },100)
                }
            })
        },

        //根据id获取名称
        getTypeName(id){
            var list = this.entsTypes
            var result = ''
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].value) {
                    result = list[i].label
                }
            }
            return result
        },
        //查询参建数据
        entFilter(){
            this.getJoinEnt()
        },
        //添加参建单位
        addEntFun(){
            this.entVisible = true
            this.addEnt = {
                id: '',
                joinType: '1',
                creditCode: '',
                entName: '',
                entId: '',
                phone: '',
                personId: ''
            }
            this.entTitle = '添加参建单位'
        },
        //获取管理人员
        getPerson() {
            var that = this
            myHttp.selectProjectPersonInfoList({
                projectId: this.groupId
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.entity || []
                    that.persons = list
                    that.teamPersons = list
                }
            })
        },
        //获取关联企业id
        getEnvFun() {
            var that = this
            myHttp.getAllEnt({
                creditCode: this.addEnt.creditCode
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data.entList && resp.data.data.entList[0]
                    if (data) {
                        that.addEnt.entName = data.name
                        that.addEnt.entId = data.id
                    } else {
                        that.addEnt.entId = ''
                    }
                }
            })
        },
        //检查手机号
        isCellPhone(val) {
            if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
                return false
            } else {
                return true
            }
        },
        //监听人员选择
        changePerson() {
            var id = this.addEnt.personId
            var list = this.persons
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].personId) {
                this.addEnt.phone = list[i].phone
                }
            }
        },
        //添加或者修改参建单位
        sumbitAddEnt(formName){
            var that = this
            this.addEnt.userId = util.session.get('user').id
            this.addEnt.projectId = this.groupId
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.addEnt.id == '') {
                    myHttp.createProjectEnt(this.addEnt).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.entVisible = false
                        that.getJoinEnt()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateProjectEnt(this.addEnt).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.entVisible = false
                        that.getJoinEnt()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                //console.log('error submit!!')
                  return false
                }
            })
        },
        //选择展示的参建企业
        getEntId(row){
            this.joinEntId = row.projectEntId
            this.entInfo = row
            this.getData()
        },

        /***
         * 获取班组
         */
        getData(){
            var that = this
            // console.log(this.joinEntId)
            myHttp.getTeams({
                projectEntId:this.joinEntId,
                projectId:this.curProjectId,
                name:this.teamName
            }).then(function(resp){
                if (resp.data.code == '200') {
                    that.tableDataEnd = resp.data.data.pageInfo || []
                    if (that.tableDataEnd.length == 0) {
                    that.dataText = '暂无数据'
                    }
                } else {
                    that.$message.error(resp.data.msg)
                    that.dataText = '暂无数据'
                }
            })
        },
        /**
         * 根据名称查询班组
         */
        doFilter(){
            this.getTeam()
        },
        /**
         * 添加班组
         */
        addTeam(){
            this.addFormVisible = true
            this.teamPersons = []
            this.getPerson()
            this.addForm = {
                id: '',
                name: '',
                teamsType: '1',
                creditCode: '',
                remarks: '',
                projectEntId: this.joinEntId,
                teamManager: '',
                managerTel: '',
                jgStatus:'',
            }
            this.diaTitle = '添加班组'
        },
        //修改班组
        handleEdit(index, row) {
            console.log(row)
            this.addFormVisible = true
            this.persons = []
            this.getPersonByTeam(row.id)
            this.addForm.id = row.id
            this.addForm.projectEntId = row.projectEntId
            this.addForm.name = row.name
            this.addForm.teamsType = row.teamsType
            if(row.teamsType=='1'){
                this.addForm.teamsTypeName = '工人'
            }else if(row.teamsType=='2'){
                this.addForm.teamsTypeName = '管理人员'
            }else if(row.teamsType=='3'){
                this.addForm.teamsTypeName = '特种'
            }else{
                this.addForm.teamsTypeName = ''
            }
            this.addForm.creditCode = row.creditCode
            this.addForm.entName = row.entName
            this.addForm.entId = row.entId
            this.addForm.remarks = row.remarks
            this.addForm.teamManager = row.teamManager
            this.addForm.managerTel = row.managerTel
            this.addForm.joinTypeName = row.joinTypeName
            this.addForm.deviceSn = row.deviceSn
            this.addForm.jgStatus = row.jgStatus
            this.diaTitle = '班组修改'
        },
        // 删除班组
        handleDelete(index, row) {
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
            myHttp
                .delTeams({
                id: row.id
                })
                .then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message({
                    type: 'success',
                    message: '删除成功!'
                    })
                    that.getData()
                } else {
                    that.$message.error(resp.data.msg)
                }
                })
            })
            .catch(err => {})
        },
        //获取班组人员
        getPersonByTeam(id){
            var that = this
            myHttp.getPersonByTeam({
                teamsId: id,
                projectId: this.groupId
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.projectPersons || []
                    that.teamPersons = list
                }
            })
        },
        // 将新增的数据添加到表格中
        sumbitAddRow(formName) {
            var that = this
            this.addForm.userId = this.$store.state.user.id
            this.addForm.projectId = this.groupId
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.addForm.id == '') {
                    myHttp.createTeams(this.addForm).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.addFormVisible = false
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateTeams(this.addForm).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.addFormVisible = false
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                //console.log('error submit!!')
                return false
                }
            })
        },
        //监听班组长判断
        changeManagerFun(e) {
            this.addForm.personId = e
            var id = this.addForm.teamManager
            var list = this.teamPersons
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].personId) {
                this.addForm.managerTel = list[i].phone
                }
            }
        },
        //获取项目中的人员
        getPersonByTeam(id) {
            var that = this
            myHttp.getPersonByTeam({
                teamsId: id,
                projectId: this.groupId
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.projectPersons || []
                    that.teamPersons = list
                }
            })
        },
        //修改参建单位
        modEnt(row){
            // console.log(row)
            this.entTitle = '参建单位修改'
            this.addEnt.id = row.projectEntId
            this.addEnt.projectEntId = row.projectEntId
            this.addEnt.joinType = row.joinType
            this.addEnt.label = row.label
            this.addEnt.creditCode = row.creditCode
            this.addEnt.entName = row.entName
            this.addEnt.entId = row.entId
            this.addEnt.name = row.personName
            this.addEnt.phone = row.personPhone
            this.entVisible = true
        },
        // 
        toTema(row){
            console.log(row)
            this.$router.push({ path: '/teamWorkerEnt/' + row.id+'/'+row.projectId }) 
        },
        /**
         * 判断是否展示
         */
        isMenuExit(row){
            var flag = util.common.filterBtnMenu(row)
            return flag
        },
        /**
         * 点击
         */
        handleNodeClick(e){
            // console.log(e)
            if(e.type=='2'){
                this.joinEntId = e.projectEntId
                this.curProjectId = e.parentId
                this.getData()
            }
        },
    }

}
</script>
<style scoped>
    
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        /* overflow: auto; */
        background: #fff;
        border-radius: 0.5vh;
        padding: 1vh 0;
        overflow: auto;
    }
    .main-left-search{
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vh;
    }
    .main-left-p{
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content:space-between;
        padding: 0 1vh;
    }
    .main-left-list{
        width: 100%;
        height: 90%;
        position: relative;
        overflow: auto;
    }
    .main-left-list li{
        width: 100%;
        height: 15%;
        position: relative;
        padding: 2vh;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }
    .main-left-list li:hover{
        background: #eee;
    }
    .curEnt{
        background: #E7F1FB;
    }
    .unit-type{
        width: 20%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-items: center;
        align-content: center;
        border: 1px solid #0365F2;
        padding: 1.5%;
    }
    .unit-name{
        width: 70%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        align-content: center;
        padding-left: 1vh;
        flex-wrap: wrap;
    }
    .unit-name p{
        width: 100%;
        text-align: left;
    }
    .main-table{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
    }
    .table-head{
        width: 100%;
        height: 6vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 2vh;
        justify-content: space-between;
    }
    .table-head-seach{
        width: 20%;
        height: 100%;
        position: relative;
    }
    .table-box{
        width: 100%;
        /* height: calc( 100% - 17vh ); */
        height: 100%;
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
    }
    .box-ent{
        width: 100%;
        height: 10vh;
        position: relative;
        margin-bottom: 1vh;
        background: #fff;
        border-radius: 5px;
        display: flex;
        /* flex-wrap: wrap; */
    }
    .box-ent-l{
        width: 80%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 2vh;
        align-content: center;
        align-items: center;
    }
    .box-ent-l p{
        width: 33%;
        height: 3vh;
        position: relative;
        text-align: left;
        padding-right: 1vh;
    }
    .box-ent-r{
        width: 20%;
        height: 100%;
        display: flex;
        align-content: center;
        align-items: center;
        margin-right: 20px;
        justify-content: flex-end
    }
</style>
<style>
@import '../../assets/css/common.css';
</style>